// The Race Space widget tags any race-space.com event link with .rsBtn and opens
// its slider on click. Links marked data-rs-skip must navigate normally, so stop
// the click before it reaches the widget's document-level listener.
window.addEventListener('click', (e) => {
	if (e.target.closest('a[data-rs-skip]')) {
		e.stopPropagation();
	}
}, true);
